// App.js
import "./App.css";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import Login from "./Component/Pages/Login";
import Registration from "./Component/Pages/Registration";
import UpdateCode from "./Component/Pages/UpdateCode";
import ForgotPassword from "./Component/Pages/ForgetPassword";
import ChangePassword from "./Component/Pages/ChangePassword";
import Admin from "./Component/Pages/Admin";
import PublicRoute from "./util/PublicRoute";
import AuthRoute from "./util/AuthRoute";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getProfile } from "./Component/store/admin/admin.action";
import { validateSessionIntegrity } from "./util/permissionIntegrity";
import { useState } from "react";

function App() {

  const dispatch = useDispatch();
  const location = useLocation();
  const [isAuthChecking, setIsAuthChecking] = useState(true);

  useEffect(() => {
    dispatch(getProfile());
  }, [dispatch])

  // Centralized Auth Validation on load
  useEffect(() => {
    const checkAuth = async () => {
      const isValid = await validateSessionIntegrity();
      if (!isValid) {
        // If tampered, stay in loading state to prevent flash of wrong route.
        // permissionIntegrity.js handles the logout and redirect.
        return;
      }
      setIsAuthChecking(false);
    };
    checkAuth();
  }, []);

  // Continue checking on route changes without blocking render
  useEffect(() => {
    if (!isAuthChecking) {
      validateSessionIntegrity();
    }
  }, [location, isAuthChecking]);

  if (isAuthChecking) {
    return null; // Show nothing while validating session to prevent flicker
  }

  return (
    <div className="App">
      <Routes>
        {/* PUBLIC AREA (guarded) */}
        <Route element={<PublicRoute />}>
          <Route path="/admin-login" element={<Login />} />
          <Route path="/forgotPassword" element={<ForgotPassword />} />
          <Route path="/changePassword" element={<ChangePassword />} />
          <Route path="/register" element={<Registration />} />
        </Route>

        {/* NON-AUTH UTILITY ROUTE (if needed) */}
        <Route path="/code" element={<UpdateCode />} />

        {/* PROTECTED AREA (guarded) */}
        <Route element={<AuthRoute />}>
          <Route path="/admin/*" element={<Admin />} />
          {/* optional: make / go to /admin */}
          <Route path="/" element={<Navigate to="/admin" replace />} />
        </Route>

        {/* Catch-all */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default App;
